export default __webpack_public_path__ + "static/media/scrooge.d296bfeb.png";